import { Component, input } from '@angular/core';
import { OnyxTooltipDirective } from '../../../directives/onyx-tooltip.directive';
import type { OnyxTooltipColor } from '../../../internal/components/onyx-tooltip-overlay/onyx-tooltip-overlay.component';
import { OnyxCustomIconComponent } from '../../icons/onyx-custom-icon/onyx-custom-icon.component';

@Component({
  selector: 'onyx-flag',
  imports: [OnyxCustomIconComponent, OnyxTooltipDirective],
  templateUrl: './onyx-flag.component.html',
  styleUrl: './onyx-flag.component.scss',
})
export class OnyxFlagComponent {
  public readonly countryCode = input.required<string>();
  public readonly size = input(16);
  public readonly showTooltip = input(true);
  public readonly tooltipColor = input<OnyxTooltipColor>('black');
}
